import * as R from 'ramda';

const getAdtVisitTypeOptions = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const getAdtVisitOccurrenceOptions = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const saveAdtHistory = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const updateAdtHistory = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const getAdtHistory = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const deleteAdtHistory = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const archiveAdtHistory = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const addAdtNote = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const getAdtNotes = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const markAdtNoteAsError = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

export default {
  getAdtVisitTypeOptions,
  getAdtVisitOccurrenceOptions,
  saveAdtHistory,
  updateAdtHistory,
  getAdtHistory,
  deleteAdtHistory,
  archiveAdtHistory,
  addAdtNote,
  getAdtNotes,
  markAdtNoteAsError
};